import { Box } from '@mui/material';
import { Dialog, TagInput } from 'components/commons';
import ja from 'utils/ja';

import { Option } from '../AutoComplete';

interface TagsDialogProps {
  open: boolean;
  onClose: () => void;
  handleConfirm: () => void;
  options: Option[];
  tags: string;
  setTags: React.Dispatch<React.SetStateAction<string>>;
}

const TagsDialog = ({
  open,
  onClose,
  handleConfirm,
  options,
  tags,
  setTags,
}: TagsDialogProps) => {
  return (
    <Dialog
      open={open}
      handleClose={onClose}
      title={ja.side_bar.tag.title}
      handleConfirm={handleConfirm}
    >
      <Box
        sx={{
          width: { xs: '80vw', sm: '520px' },
          gap: '10px',
          padding: '10px',
        }}
      >
        <Box>
          <TagInput
            id='tag'
            label={ja.side_bar.tag.label}
            placeholder={ja.side_bar.tag.placeholder}
            limitTags={3}
            value={tags}
            onChange={(value: string) => setTags(value)}
            options={options}
            required
          />
        </Box>
      </Box>
    </Dialog>
  );
};
export default TagsDialog;
